import type { SxProps, Theme } from "@mui/material/styles";

/**
 * Normalises an optional `SxProps<Theme>` value into a flat array of
 * individual sx items suitable for spreading into an MUI `sx` array.
 *
 * MUI's sx array accepts `Array<SystemStyleObject | boolean | callback>`;
 * it does NOT accept nested arrays, so we must unwrap the array form of
 * `SxProps` rather than wrapping it again.
 *
 * @example
 * <Box sx={[baseSx, ...toSxArray(optionalSx)]} />
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toSxArray = (sx: SxProps<Theme> | undefined): any[] => {
  if (sx == null) {
    return [];
  }
  return Array.isArray(sx) ? [...sx] : [sx];
};
